import type { FC } from 'react'
import { useDebounce } from 'react-use'
import { useRecipientSelect, useSafeSelectOpsDispatch } from '../page/RecipientSelectProvider'
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import TextInputField from '@g4g/ui/src/internal/text/TextInputField'
import useRecipientGifters from '../hooks/useRecipientGifters'

const SEARCH_DEBOUNCE_MS = 1000

const GiftSearchBar: FC = () => {
  const dispatch = useSafeSelectOpsDispatch()
  const { searchQuery } = useRecipientSelect()
  const { refetch } = useRecipientGifters()

  /**
   * We do not want to search on every keystroke
   * so lets debounce the search string change
   * for SEARCH_DEBOUNCE_MS
   */
  useDebounce(
    /**
     * The debouncing is finished here so we refetch
     * with the updated searchQuery.
     *
     */
    async () => await refetch(),
    SEARCH_DEBOUNCE_MS,
    [searchQuery]
  )

  return (
    <TextInputField
      data-cy="shop-recipients-search-input"
      placeholder="Search users or full user IDs..."
      icon={<MagnifyingGlassIcon />}
      onChange={({ currentTarget }) => {
        const query = currentTarget.value

        /**
         * Searching starts here, so this
         * will set the `useGift() -> searching` to
         * true as well
         */
        // reset
        dispatch({ type: 'update-search-query', query, searching: query.length > 1 })
      }}
    />
  )
}

export default GiftSearchBar
